import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo-anisen-couleur.svg'


const _withScopeId = n => (_pushScopeId("data-v-ddb04432"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "anisen",
    src: _imports_0
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserSection = _resolveComponent("UserSection")!
  const _component_SidebarMenu = _resolveComponent("SidebarMenu")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_UserSection),
    _createVNode(_component_SidebarMenu)
  ]))
}